<template>
  <Transition name="slide-up">
    <!-- Deliberately not a modal: an ERP user is mid-task, and a new version is
         not urgent enough to interrupt them. It waits at the bottom until they
         are ready. -->
    <div v-if="updateAvailable" class="update" role="status">
      <AppIcon name="refresh" :size="18" />

      <div class="grow">
        <p class="update__title">{{ t('pwa.updateTitle') }}</p>
        <p class="update__text">{{ t('pwa.updateText') }}</p>
      </div>

      <UiButton size="sm" @click="applyUpdate">{{ t('pwa.updateNow') }}</UiButton>
      <button type="button" class="update__later" @click="dismissUpdate">
        {{ t('pwa.updateLater') }}
      </button>
    </div>
  </Transition>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import { UiButton } from '@general/ui-kit'

import AppIcon from './AppIcon.vue'
import { updateAvailable, applyUpdate, dismissUpdate } from '../app/pwa'

const { t } = useI18n()
</script>

<style scoped>
.update {
  position: fixed;
  left: 50%;
  bottom: var(--space-5);
  transform: translateX(-50%);
  z-index: 180;
  display: flex;
  align-items: center;
  gap: var(--space-3);
  width: min(560px, calc(100vw - 2 * var(--space-4)));
  padding: var(--space-3) var(--space-4);
  background: var(--color-surface);
  border: 1px solid var(--color-primary);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-lg);
  color: var(--color-text);
}
.update svg { color: var(--color-primary); }

.update__title { font-size: var(--text-sm); font-weight: 600; }
.update__text { font-size: var(--text-xs); color: var(--color-text-soft); }

.update__later {
  border: none;
  background: none;
  font-size: var(--text-xs);
  color: var(--color-text-mute);
}
.update__later:hover { color: var(--color-text); }

/* The transform on the wrapper fights the transition's own, so the enter and
   leave states restate it. */
.slide-up-enter-from,
.slide-up-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(12px);
}
</style>
